import memoize from 'fast-memoize'
import isNil from 'lodash/isNil'
import styled, { css } from 'styled-components'

type JustifyContentType =
  | 'center'
  | 'start'
  | 'end'
  | 'flex-start'
  | 'flex-end'
  | 'left'
  | 'right'
  | 'normal'
  | 'space-between'
  | 'space-around'
  | 'space-evenly'
  | 'stretch'
  | 'safe'
  | 'unsafe'
  | 'inherit'
  | 'initial'
  | 'unset'

type AlignItemsType =
  | 'normal'
  | 'stretch'
  | 'center'
  | 'start'
  | 'end'
  | 'flex-start'
  | 'flex-end'
  | 'self-start'
  | 'self-end'
  | 'baseline'
  | 'safe '
  | 'unsafe '
  | 'inherit'
  | 'initial'
  | 'unset'

type WrapType = 'inherit' | 'initial' | 'nowrap' | 'wrap' | 'wrap-reverse' | 'unset'

export type PropsType = {
  readonly alignItems?: AlignItemsType
  readonly alignSelf?: AlignItemsType
  readonly basis?: 'auto' | number | string
  readonly grow?: number
  readonly justifyContent?: JustifyContentType
  readonly shrink?: number
  readonly wrap?: WrapType
}

const interpolation = memoize(
  (cssPropName: string, cssValue: keyof PropsType) => (props: PropsType) => {
    if (isNil(props[cssValue])) {
      return undefined
    }

    return `${cssPropName}: ${props[cssValue]};`
  }
)

export const flexCss = css`
  display: flex;
  ${interpolation('flex-wrap', 'wrap')};
  ${interpolation('flex-basis', 'basis')};
  ${interpolation('flex-grow', 'grow')};
  ${interpolation('flex-shrink', 'shrink')};
  ${interpolation('align-items', 'alignItems')};
  ${interpolation('justify-content', 'justifyContent')};
  ${interpolation('flex-grow', 'grow')};
`

const Column = styled.div<PropsType>`
  ${flexCss};
  flex-direction: column;
`

export default Column
